import sourceMeta from './data/bwpEia861SourceMeta.generated.json';

export const EIA861_EXPECTED_YEAR_MIN = 2005;
export const EIA861_EXPECTED_YEAR_MAX = 2024;
export const EIA861_EXPECTED_YEARS = Array.from(
  { length: EIA861_EXPECTED_YEAR_MAX - EIA861_EXPECTED_YEAR_MIN + 1 },
  (_, i) => EIA861_EXPECTED_YEAR_MIN + i
);

export interface Eia861SourceCompleteness {
  expected_years: number[];
  downloaded_years: number[];
  processed_years: number[];
  observed_years: number[];
  missing_source_years: number[];
  missing_utility_rows: number[];
  source_range_complete: boolean;
  sourceCsvSha256?: string;
}

export function getBwpSourceCompleteness(): Eia861SourceCompleteness {
  return sourceMeta as Eia861SourceCompleteness;
}

export class Eia861SourceNotReadyError extends Error {
  constructor(
    message: string,
    public readonly completeness: Eia861SourceCompleteness
  ) {
    super(message);
    this.name = 'Eia861SourceNotReadyError';
  }
}

export function assertBurbankEia861SourceReady(): void {
  const c = getBwpSourceCompleteness();
  if (!c.source_range_complete) {
    throw new Eia861SourceNotReadyError(
      `Burbank EIA-861 pilot inactive: missing years ${c.missing_source_years.join(', ')}`,
      c
    );
  }
}
